module.exports = __webpack_public_path__ + "static/garda_main_5-869686e30f1877a6ef35b8ed94dded43.png";